export default {
  getAdvertisers: state => state.advertisers,
  getSetupMode: (state, getters) => {
    const user = getters.getCurrentUser
    if (!user) return {status: false, items: []}
    const advertiser = state.advertisers.find(a => a.id === user.firebaseAccount.selectedAdvertiser)
    return advertiser ? advertiser.data.setupMode : {status: false, items: []}
  },
  isSetupModeItemsCompleted: (state, getters) => {
    const setupMode = getters.getSetupMode
    if (!setupMode) return false
    return !setupMode.items.reduce((acc, cur) => [...acc, ...cur.tasks], [])
      .find(task => !task.completed)
  }
}
